/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 16:27:02
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-24 19:01:27
 */
import Layout from '@/layout'
export default [
  {
    path: '/system',
    name: 'System',
    component: Layout,
    redirect: '/system/admin',
    meta: { level: 1, title: '系统管理', icon: 'el-icon-setting' },
    children: [
      {
        path: 'role',
        name: 'role',
        component: () => import(/*webpackChunkName:'Role'*/ '@/views/system/roleManage/index'),
        meta: { title: '角色管理' },
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import(/*webpackChunkName:'Admin'*/ '@/views/system/userManage/index'),
        meta: { title: '管理员管理' },
      },
      {
        path: 'reviewer',
        name: 'Reviewer',
        component: () => import(/*webpackChunkName:'Reviewer'*/ '@/views/system/Reviewer/index'),
        meta: { title: '阅卷人管理' },
      },
      {
        path: 'proctor',
        name: 'Proctor',
        component: () => import(/*webpackChunkName:'Proctor'*/ '@/views/system/Proctor/index'),
        meta: { title: '监考员管理' },
      },
      {
        path: 'reviewer/add',
        name: 'ReviewerAdd',
        component: () =>
          import(/*webpackChunkName:'ReviewerAdd'*/ '@/views/system/Reviewer/addFromAdmin'),
        meta: { title: '添加阅卷人' },
      },
      {
        path: 'proctor/add',
        name: 'ProctorAdd',
        component: () =>
          import(/*webpackChunkName:'ProctorAdd'*/ '@/views/system/Proctor/addFromAdmin'),
        meta: { title: '添加监考员' },
      },
      {
        path: 'adminAdd',
        name: 'adminAdd',
        hidden: true,
        component: () =>
          import(/*webpackChunkName:'userManage'*/ '@/views/system/userManage/adminAdd'),
        meta: { title: '添加管理员' },
      },
    ],
  },
]
